export class ConfirmDialog {
  open(message: string, showCancel: boolean, timeout?: number): Promise<boolean> {
    return Promise.resolve(false);
  }
}